import { SelfServeNodes } from "../types";

import { useExclusivityRetailerNodes } from "./nodes/useExclusivityRetailerNodes";
import { useHowFaireWorksRetailerNodes } from "./nodes/useHowFaireWorksRetailerNodes";
import { useInsiderMembershipRetailerNodes } from "./nodes/useInsiderMembershipRetailerNodes";
import { useInvoicesAndPaymentsRetailerNodes } from "./nodes/useInvoicesAndPaymentsRetailerNodes";
import { useMyAccountRetailerNodes } from "./nodes/useMyAccountRetailerNodes";
import { useOrdersAndShippingRetailerNodes } from "./nodes/useOrdersAndShippingRetailerNodes";
import { useReferralsRetailerNodes } from "./nodes/useReferralsRetailerNodes";

export const useRetailerNodesV1 = (): SelfServeNodes => {
  const ORDERS_AND_SHIPPING_NODES = useOrdersAndShippingRetailerNodes();
  const MY_ACCOUNT_NODES = useMyAccountRetailerNodes();
  const INVOICES_AND_PAYMENTS_NODES = useInvoicesAndPaymentsRetailerNodes();
  const INSIDER_MEMBERSHIP_NODES = useInsiderMembershipRetailerNodes();
  const EXCLUSIVITY_NODES = useExclusivityRetailerNodes();
  const REFERRALS_NODES = useReferralsRetailerNodes();
  const HOW_FAIRE_WORKS_NODES = useHowFaireWorksRetailerNodes();

  return {
    Root: {
      id: "Root",
      children: [
        "OrdersAndShipping",
        "MyAccount",
        "InvoicesAndPayments",
        "InsiderMembership",
        "Exclusivity",
        "Referrals",
        "HowFaireWorks",
      ],
      level: 0,
    },
    ...ORDERS_AND_SHIPPING_NODES,
    ...MY_ACCOUNT_NODES,
    ...INVOICES_AND_PAYMENTS_NODES,
    ...INSIDER_MEMBERSHIP_NODES,
    ...EXCLUSIVITY_NODES,
    ...REFERRALS_NODES,
    ...HOW_FAIRE_WORKS_NODES,
  };
};
